import axiosClient from '@services/axiosClient';
import EndPoints from '@services/endpoints';
import { AxiosResponse } from 'axios';

import GetVideoStepItemDto from '@settings/models/dto/get-video-step-item.dto';
import UpdateVideoStepItemDto from '@settings/models/dto/update-video-step-item.dto';
import CreateVideoStepDto from '@settings/models/dto/create-video-step.dto';

export const getVideoSteps = async (): Promise<
  AxiosResponse<GetVideoStepItemDto[]>
> => {
  return await axiosClient.get(EndPoints.videoSteps.getVideoSteps());
};

export const updateVideoStepById = async (
  id: string,
  payload: UpdateVideoStepItemDto,
): Promise<AxiosResponse<string>> => {
  return await axiosClient.put(
    EndPoints.videoSteps.updateVideoStepById(id),
    payload,
  );
};

export const updateVideoStepsOrder = async (
  payload: { id: string; rank: number }[],
): Promise<AxiosResponse<string>> => {
  return await axiosClient.put(
    EndPoints.videoSteps.updateVideosOrder(),
    payload,
  );
};

export const enableVideoStepById = async (
  id: string,
): Promise<AxiosResponse<string>> => {
  return await axiosClient.put(EndPoints.videoSteps.enableVideoStepById(id));
};

export const disableVideoStepById = async (
  id: string,
): Promise<AxiosResponse<string>> => {
  return await axiosClient.put(EndPoints.videoSteps.disableVideoStepById(id));
};

export const createCvVideoStep = async (
  payload: CreateVideoStepDto,
): Promise<AxiosResponse<string>> => {
  return await axiosClient.post(
    EndPoints.videoSteps.createVideoStep(),
    payload,
  );
};

export const editCvVideoStep = async (
  id: string,
  payload: CreateVideoStepDto,
): Promise<AxiosResponse<string>> => {
  return await axiosClient.patch(
    EndPoints.videoSteps.editVideoStepById(id),
    payload,
  );
};
